<template>
  <el-dialog v-dialogDrag :visible.sync="dialogAdd" width="1200px" :close-on-click-modal="false" :before-close="resetAdd">
    <span slot="title" class="dialog-title">添加过程结算</span>
    <div class="dialoginfo">
      <el-form ref="reffromDate" :model="fromDate" :rules="rules" label-width="150px">
        <div style="display: flex">
          <el-form-item prop="currentSettlementQuantity">
            <span slot="label">
              <span style="color: red">结算数量（方）</span>
            </span>
            <el-input
              v-model="fromDate.currentSettlementQuantity"
              style="width: 360px"
              onkeyup="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              onafterpaste="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              :disabled="isDisabledType"
              @input="updateSettlement"
            ></el-input>
          </el-form-item>
          <el-form-item prop="currentSettlementAmount">
            <span slot="label">
              <span style="color: red">结算金额（元）</span>
            </span>
            <el-input
              v-model="fromDate.currentSettlementAmount"
              onkeyup="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              onafterpaste="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              :disabled="isDisabledType"
              @input="updateSettlement"
            ></el-input>
          </el-form-item>
        </div>
        <div v-if="isShowType" style="display: flex">
          <el-form-item prop="cumulativeSettlementQuantity">
            <span slot="label">
              <span style="color: red">累计结算数量（方）</span>
            </span>
            <el-input
              v-model="fromDate.cumulativeSettlementQuantity"
              style="width: 360px"
              onkeyup="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              onafterpaste="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              :disabled="isDisabledType || isUpdate"
            ></el-input>
          </el-form-item>
          <el-form-item prop="cumulativeSettlementAmount">
            <span slot="label">
              <span style="color: red">累计结算金额（元）</span>
            </span>
            <el-input 
              v-model="fromDate.cumulativeSettlementAmount" 
              onkeyup="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''" 
              onafterpaste="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''" 
              :disabled="isDisabledType || isUpdate" 
              >
            </el-input>
          </el-form-item>
        </div>
        <div style="display: flex">
          <el-form-item prop="startTimDateEndTimDate">
            <span slot="label">
              <span style="color: red">结算周期</span>
            </span>
            <!-- :disabled="isDisabledType" -->
            <!-- <el-date-picker
              v-model="fromDate.settlementPeriodLook"
              style="width: 360px"
              unlink-panels
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              :default-time="['06:00:00', '06:00:00']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker> -->
            <el-date-picker
              v-model="fromDate.startTimDateEndTimDate"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
             @change="handleDateChange"
              >
              <!--  @change="(fromDate.startTime = startTimDateEndTimDate[0] || ''), (fromDate.endTime = startTimDateEndTimDate[1] || '')" -->
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="settlementNumber">
            <span slot="label">
              <span style="color: red">编号</span>
            </span>
            <el-input v-model="fromDate.settlementNumber" :disabled="isDisabledType"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="审核说明">
          <el-input v-model="fromDate.auditNotes" style="width: 750px" placeholder="请填写审核说明" class="textarea" type="textarea" resize="none" rows="3" :disabled="isDisabledType"></el-input>
        </el-form-item>
        <el-form-item label="事项说明">
          <el-input v-model="fromDate.internalEventExplain" style="width: 750px" placeholder="请填写事项说明" class="textarea" type="textarea" resize="none" rows="3" :disabled="isDisabledType"></el-input>
        </el-form-item>
        <el-form-item>
          <span slot="label">
            <span>附件</span>
          </span>
          <div style="padding-left: 42px">
            <!-- fileCode="priceFile" -->
            <FileComponent2 fileCode="modifyPriceFile" :files="files"   @deleteFile="deleteFile"  @uplodeSuccess="uplodeSuccess" />
          </div>
        </el-form-item>
        <div v-if="isBackType" style="display: flex">
          <el-form-item prop="returnSettlementQuantityCurrent">
            <span slot="label">
              <span>返回结算数量（方）</span>
            </span>
            <el-input
              v-model="fromDate.returnSettlementQuantityCurrent"
              style="width: 360px"
              onkeyup="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              onafterpaste="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              disabled
              ></el-input>
          </el-form-item>
          <el-form-item prop="returnSettlementAmountCurrent">
            <span slot="label">
              <span>返回结算金额（元）</span>
            </span>
            <el-input
              v-model="fromDate.returnSettlementAmountCurrent"
              onkeyup="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              onafterpaste="this.value = this.value.match(/\-?(\d+(\.\d{0,2})?)?/) ? this.value.match(/\-?(\d+(\.\d{0,2})?)?/)[0] : ''"
              disabled
              ></el-input>
          </el-form-item>
        </div>
        <!-- <el-form-item  v-if="isBackType" label="备注">
          <el-input v-model="fromDate.field1" style="width: 750px" placeholder="请填写备注" class="textarea" type="textarea" resize="none" rows="3" :disabled="isDisabledType" ></el-input>
        </el-form-item> -->
        <el-form-item v-if="isBackType" label="审核说明">
          <el-input v-model="fromDate.confirmAuditDescription" style="width: 750px" placeholder="请填写审核说明" class="textarea" type="textarea" resize="none" rows="3"></el-input>
        </el-form-item>
        <el-form-item v-if="isBackType">
          <span slot="label">
            <span>附件</span>
          </span>
          <div style="padding-left: 42px">
            <!-- fileCode="priceFile" -->
            <FileComponent2 fileCode="modifyPriceFile" :files="files1"   @deleteFile="deleteFile1"  @uplodeSuccess="uplodeSuccess1" />
          </div>
        </el-form-item>
        <el-form-item v-if="isBackType">
          <span slot="label">
            <span>附件</span>
          </span>
          <div style="padding-left: 42px">
            <!-- fileCode="priceFile" -->
            <FileComponent2 fileCode="modifyPriceFile" :files="files2"   @deleteFile="deleteFile2"  @uplodeSuccess="uplodeSuccess2" />
          </div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="resetAdd">取 消</el-button>
      <el-button class="bottom_one" style="margin-left: 24px" @click="submitAdd(0)">保 存</el-button>
      <el-button v-if="isDisabledType" class="bottom_one" style="margin-left: 24px" @click="submitAdd(1)">提 交</el-button>
      <!--  v-if="scope.row.firstSure == 0 && ButtonList.findIndex(res => res.buttonValue == 'QUEREN') !== -1" -->
      <el-button v-if="fromDate.firstSure == 1 " class="bottom_three" style="margin-left: 24px" @click="confirmItem()"> 确 认 </el-button>
    </span>
  </el-dialog>
</template>
<script>
import FileComponent2 from "@/views/platform/ICPS/internetSales/components/fileComponent";
import { saveSettlement } from "@/api/internetSales/engineeringControl.js";
export default {
  components: {
    FileComponent2,
  },
  props: {
    dialogAdd: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: new Object(),
    },
    paramsFromDate: {
      type: Object,
      default: new Object(),
    },
    isBack: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    isUpdate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      row: {},
      files: [],
      files1: [],
      files2: [],
      isUpload:false,
      settlementPeriodLook: [],
      rules: {
        currentSettlementQuantity: [{ required: true, message: "请输入结算数量", trigger: "blur" }],
        currentSettlementAmount: [{ required: true, message: "请输入结算金额", trigger: "blur" }],
        settlementNumber: [{ required: true, message: "请输入编号", trigger: "blur" }],
        startTimDateEndTimDate: [{ required: true, message: "请选择结算周期", trigger: "change" }],
        // startTimDateEndTimDate: [{ required: true, message: "请选择结算周期", trigger: "change" }],
        // returnSettlementQuantityCurrent: [{ required: true, message: "请输入返回结算数量", trigger: "blur" }],
        // returnSettlementAmountCurrent: [{ required: true, message: "请输入返回结算金额", trigger: "blur" }],
      },
      isBackType: false,
      isDisabledType:false,
      isShowType:false,
      startTimDateEndTimDate:[],
      fromDate: {
        id: "",
        currentSettlementQuantity: "",
        cumulativeSettlementQuantity: "",
        currentSettlementAmount: "",
        cumulativeSettlementAmount: "",
        settlementNumber: "",
        settlementPeriodLook: [],
        settlementPeriod: "",
        returnSettlementQuantityCurrent: "",
        returnSettlementAmountCurrent: "",
        auditNotes: "",
        engineeringId: "",
        startTime:"",
        endTime:"",
        type: 1,
      },
    };
  },
  watch: {
    dialogAdd() {
      if (this.dialogAdd) {
        this.isBackType = this.isBack;
        this.isDisabledType = this.isDisabled;
        this.isShowType = this.isShow;
        this.row = this.params;
        console.log("=====================================")
        console.log(this.row)
        this.fromDate = this.paramsFromDate;
        if(!this.fromDate.startTime){
          this.$set(this.fromDate, 'startTimDateEndTimDate', []);
        }else{
          // var array = []
          // array[0] = this.fromDate.startTime
          // array[1] = this.fromDate.endTime
          // this.startTimDateEndTimDate = array
          this.$set(this.fromDate, 'startTimDateEndTimDate', [this.fromDate.startTime, this.fromDate.endTime]);
        }
        console.log(this.fromDate)
        console.log(this.startTimDateEndTimDate)
        // this.startTimDateEndTimDate = []
        // if (this.fromDate.settlementPeriod?.length != 0) {
        //   //   const settlementPeriod = "2024-04-09 06:00:00-2024-05-14 06:00:00";
        //   // 使用 '-' 符号分割字符串
        //   const dateArray = this.fromDate.settlementPeriod.split(",");
        //   // 存储两个日期值
        //   const startDate = dateArray[0].trim(); // 去除空格
        //   const endDate = dateArray[1].trim(); // 去除空格
        //   // 将两个日期值存入数组
        //   this.fromDate.settlementPeriodLook = [startDate, endDate];
        // }
        // if (this.fromDate.attachment != "" && this.fromDate.attachment != "[]") {
        //   this.files = JSON.parse(this.fromDate.attachment);
        //   this.isUpload = true
        // } else {
        //   this.files = [];
        //   this.isUpload = false
        // }
        if (this.fromDate.internalEnclosureUrl && this.fromDate.internalEnclosureUrl != "[]") {
          this.files = JSON.parse(this.fromDate.internalEnclosureUrl);
          this.isUpload = true
        } else {
          this.files = [];
          this.isUpload = false
        }
        if (this.fromDate.confirmEnclosureUrl  && this.fromDate.confirmEnclosureUrl != "[]") {
          this.files1 = JSON.parse(this.fromDate.confirmEnclosureUrl);
          this.isUpload = true
        } else {
          this.files1 = [];
          this.isUpload = false
        }
        if (this.fromDate.totalSettlementAttachment && this.fromDate.totalSettlementAttachment != "[]") {
          this.files2 = JSON.parse(this.fromDate.totalSettlementAttachment);
          this.isUpload = true
        } else {
          this.files2 = [];
          this.isUpload = false
        }
      }
    },
  },
  methods: {
    handleDateChange(val) {
      if (val && val.length > 0) {
        this.fromDate.startTime = val[0];
        this.fromDate.endTime = val[1];
      } else {
        this.fromDate.startTime = '';
        this.fromDate.endTime = '';
      }
    },
    updateSettlement() {
        this.fromDate.returnSettlementAmountCurrent = this.fromDate.currentSettlementAmount;
        this.fromDate.returnSettlementQuantityCurrent = this.fromDate.currentSettlementQuantity;
    },
    uplodeSuccess(data) {
      const params = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      this.files.push(params);
    },
    uplodeSuccess1(data) {
      const params = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      this.files1.push(params);
    },
    uplodeSuccess2(data) {
      const params = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      this.files2.push(params);
    },
    deleteFile(index) {
      this.files.splice(index, 1);
    },
    deleteFile1(index) {
      this.files1.splice(index, 1);
    },
    deleteFile2(index) {
      this.files2.splice(index, 1);
    },
    resetAdd() {
      this.startTimDateEndTimDate = []
      this.$emit("resetAdd", false);
      this.$parent.init(this.row.id);
    },
    confirmItem() {
      this.$confirm("此操作将确认该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          var params = {
            id: this.fromDate.id,
          };
            params.firstSure = 2
          saveSettlement(params).then(res => {
            if (res.code == 1001) {
              this.$message.success("已确认该数据");
              this.resetAdd();
            }
          });
        })
        .catch(() => {});
    },
    // submitAdd(){
    //   console.log("()*)*)GJGJGJHGUYR^$%&^$&^$")
    //   console.log(this.fromDate)
    // },
    submitAdd(status) {
      //   var isURL = false;
      //   if (this.files?.length == 0) {
      //     isURL = true;
      //   }
      this.fromDate.attachment = JSON.stringify(this.files);
      this.fromDate.internalEnclosureUrl = JSON.stringify(this.files);
      this.fromDate.confirmEnclosureUrl = JSON.stringify(this.files1);
      this.fromDate.totalSettlementAttachment = JSON.stringify(this.files2);
      // this.fromDate.settlementPeriod = `${this.fromDate.settlementPeriodLook[0]},${this.fromDate.settlementPeriodLook[1]}`;
      
      //   if (isURL) {
      //     this.$message.warning("请上传附件");
      //     return;
      //   } else {
      this.$refs.reffromDate.validate(valid => {
        if (valid) {
          console.log(this.fromDate);
          this.fromDate.engineeringId = this.row.id;
          this.fromDate.cumulativeSettlementQuantity = this.fromDate.cumulativeSettlementQuantity *1;
          this.fromDate.cumulativeSettlementAmount = this.fromDate.cumulativeSettlementAmount *1;
          console.log(this.fromDate)
          this.fromDate.returnSettlementAmountCumulative = this.fromDate.cumulativeSettlementAmount *1;
          this.fromDate.returnSettlementQuantityCumulative = this.fromDate.cumulativeSettlementQuantity *1;
          // 填写返回数据改变状态值为1已提交
          if(this.isDisabledType && this.fromDate.firstSure == 0){
            this.fromDate.firstSure = status
          }
          saveSettlement(this.fromDate).then(res => {
            if (res.code == 1001) {
              this.$message({
                message: "保存成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data,
                type: "warning",
              });
            }
            this.$emit("resetAdd", false);
            this.$parent.init(this.row.id);
            this.files = []
          });
        } else {
          return false;
        }
      });
      //   }
    },
  },
};
</script>
<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}
.title {
  font-weight: bold;
  font-size: 18px;
  padding-bottom: 18px;
}
</style>
